import { TThunkAction } from '../../types/redux';
import { searchRegions } from '../../api/location';
import { ILocation } from '../../types/location';

export function findRegionByName(name: string): TThunkAction<Promise<ILocation[]>> {
  return async (dispatch, getState, context) => {
    return searchRegions(context, name);
  };
}
